import { createGenericStore } from "../../shared/store/genericStore";

import type { Category } from "./types";

export const useCategoriesStore = createGenericStore<Category>();